import React, { Fragment } from 'react';
import { clsx } from '../../utils/helper';
import arrowStatus from '../../assets/icons/arrow_status.png'

const StatusList = ({ className = '', listStatus, currentStatus }) => {

    const checkActive = status => {
        return Array.isArray(status) ? status.indexOf(currentStatus) : (status === currentStatus) - 1
    }

    const getActiveIcon = (activeImg, indexActive) => {
        return Array.isArray(activeImg) ? activeImg[indexActive] : activeImg
    }

    return (
        <div className={clsx(['order-status-list', className])}>
            {listStatus.map((el, index) => {
                const indexActive = checkActive(el.status)
                const icon = indexActive === -1 ? el.inactiveImg : getActiveIcon(el.activeImg, indexActive)
                return (
                    <Fragment key={index}>
                        <div className={clsx(['status-item', indexActive !== -1 && 'active'])}>
                            <img className="content" src={icon} />
                        </div>
                        {index != listStatus.length - 1 && <img className="status-arrow" src={arrowStatus} />}
                    </Fragment>
                )
            })}
        </div>
    );
};

export default StatusList;